import {
  JoinChaveForm,
  JoinConfig,
  JoinConfigForm,
  JoinFiltroForm,
  TransformacaoJoin
} from '../../../types/smartinteg';

export const TRANSFORMACOES_JOIN: { label: string; value: TransformacaoJoin }[] = [
  { label: 'Texto (sem transformação)', value: 'TEXTO' },
  { label: 'Extrair ano', value: 'EXTRAIR_ANO' },
  { label: 'Extrair mês (sem zero à esquerda)', value: 'EXTRAIR_MES' },
  { label: 'Extrair dia (2 dígitos)', value: 'EXTRAIR_DIA' },
  { label: 'Extrair ano e mês (ex.: 202401)', value: 'EXTRAIR_ANO_MES' }
];

export function novaChave(): JoinChaveForm {
  return { modo: 'CAMPO', campo: '', transformacao: 'TEXTO', valorFixo: '' };
}

export function novoFiltro(): JoinFiltroForm {
  return { campoRegistro: '', transformacao: 'EXTRAIR_DIA', campoInicio: '', campoFim: '' };
}

export function novoJoinForm(): JoinConfigForm {
  return { datasetId: null, comportamentoSemMatch: 'DEIXAR_VAZIO', chaves: [novaChave()], filtros: [], campos: [{ origem: '', destino: '' }] };
}

/** Lê Recurso.configuracoes.join (formato do backend) para o formulário */
export function lerJoinConfig(join: Partial<JoinConfig> | null | undefined): JoinConfigForm {
  if (!join) return novoJoinForm();
  return {
    datasetId: join.datasetId ?? null,
    comportamentoSemMatch: join.comportamentoSemMatch ?? 'DEIXAR_VAZIO',
    chaves: (join.camposChaveDestino ?? []).map(c =>
      c.valorFixo !== undefined && c.valorFixo !== null
        ? { modo: 'FIXO' as const, campo: '', transformacao: 'TEXTO' as const, valorFixo: c.valorFixo }
        : { modo: 'CAMPO' as const, campo: c.campo ?? '', transformacao: c.transformacao ?? 'TEXTO', valorFixo: '' }),
    filtros: (join.filtrosRange ?? []).map(f => ({
      campoRegistro: f.campoRegistro, transformacao: f.transformacao ?? 'EXTRAIR_DIA', campoInicio: f.campoInicio, campoFim: f.campoFim
    })),
    campos: (join.campos ?? []).map(c => ({ origem: c.origem, destino: c.destino }))
  };
}

/** Monta o objeto gravado em Recurso.configuracoes.join */
export function montarJoinConfig(form: JoinConfigForm): JoinConfig {
  return {
    datasetId: form.datasetId as number,
    comportamentoSemMatch: form.comportamentoSemMatch,
    camposChaveDestino: form.chaves.map(c =>
      c.modo === 'FIXO' ? { valorFixo: c.valorFixo } : { campo: c.campo.trim(), transformacao: c.transformacao }),
    filtrosRange: form.filtros.map(f => ({
      campoRegistro: f.campoRegistro.trim(), transformacao: f.transformacao, campoInicio: f.campoInicio.trim(), campoFim: f.campoFim.trim()
    })),
    // O backend só copia; "tipo" não é lido, mas é enviado por compatibilidade com o formato documentado
    campos: form.campos.map(c => ({ origem: c.origem.trim(), destino: c.destino.trim(), tipo: 'COPIAR' as const }))
  };
}

/** Primeiro problema do formulário, ou null se está pronto para salvar */
export function validarJoin(form: JoinConfigForm): string | null {
  if (!form.datasetId) return 'Selecione o dataset do JOIN.';
  if (form.chaves.length === 0) return 'Informe ao menos uma parte da chave de busca.';
  for (const [i, c] of form.chaves.entries()) {
    if (c.modo === 'CAMPO' && !c.campo.trim()) return `Chave de busca, parte ${i + 1}: informe o campo do registro.`;
    if (c.modo === 'FIXO' && !c.valorFixo.trim()) return `Chave de busca, parte ${i + 1}: informe o valor fixo.`;
  }
  for (const [i, f] of form.filtros.entries()) {
    if (!f.campoRegistro.trim() || !f.campoInicio.trim() || !f.campoFim.trim()) {
      return `Filtro de intervalo ${i + 1}: informe o campo do registro e os campos de início e fim do dataset.`;
    }
  }
  if (form.campos.length === 0) return 'Informe ao menos um campo a copiar do dataset (sem campos o JOIN não faz nada).';
  for (const [i, c] of form.campos.entries()) {
    if (!c.origem.trim() || !c.destino.trim()) return `Campo copiado ${i + 1}: informe a origem (dataset) e o destino (registro).`;
  }
  const destinos = form.campos.map(c => c.destino.trim().toLowerCase());
  const repetido = destinos.find((d, i) => destinos.indexOf(d) !== i);
  if (repetido) return `O campo de destino "${repetido}" aparece mais de uma vez.`;
  return null;
}

/** Como a chave composta será montada (valores unidos por "|"), para conferir com a chave do dataset */
export function previewChave(form: JoinConfigForm): string {
  return form.chaves
    .map(c => c.modo === 'FIXO'
      ? (c.valorFixo.trim() || '?')
      : `${c.transformacao === 'TEXTO' ? '' : c.transformacao + ' de '}${c.campo.trim() || '?'}`)
    .join(' | ');
}

/** Nome dos campos do dataset: chaves + campos vistos nos registros (dados de amostra) */
export function camposDoDataset(chaves: string[], amostra: Record<string, any>[]): string[] {
  const todos = new Set<string>(chaves ?? []);
  amostra.forEach(d => Object.keys(d ?? {}).forEach(k => todos.add(k)));
  return [...todos];
}
